import { Button, Table } from 'antd'
import dayjs from 'dayjs'
import * as XLSX from 'xlsx'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm from '../common/ModalConfirm/ModalConfirm'
const ModalListHouse = ({
  data = [],
  isModalOpen,
  onClose,
  project,
  loading
}) => {
  const formattedData = data?.map((item, index) => ({
    ...item,
    stt: index + 1
  }))

  const columns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt'
    },
    {
      title: 'Dự Án',
      dataIndex: 'project',
      key: 'project',
      render: (text) => project.name || '-'
    },
    {
      title: 'Thời gian',
      dataIndex: 'date_view',
      key: 'date_view',
      render: (text) => {
        return text ? dayjs(text).format('DD/MM/YYYY') : '-'
      }
    },
    {
      title: 'Giờ',
      dataIndex: 'date_view',
      key: 'date_view',
      render: (text) => {
        return text ? dayjs(text).format('HH:mm:ss') : '-'
      }
    },
    {
      title: 'Họ và tên',
      dataIndex: 'customer_name',
      key: 'customer_name',
      render: (text) => text || '-'
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'customer_phone',
      key: 'customer_phone',
      render: (text) => text || '-'
    },
    {
      title: 'Email',
      dataIndex: 'customer_email',
      key: 'customer_email',
      render: (text) => text || '-'
    },
    {
      title: 'Ngày đăng ký',
      dataIndex: 'created_at',
      render: (text) => {
        return text ? dayjs(text).format('HH:mm:ss DD/MM/YYYY') : '-'
      }
    }
  ]

  const headerMap = {
    stt: 'STT',
    project: 'Dự án',
    date_view: 'Thời gian',
    time: 'Giờ',
    customer_name: 'Họ và tên',
    customer_phone: 'Số điện thoại',
    customer_email: 'Email',
    created_at: 'Ngày đăng ký'
  }
  const exportToExcel = () => {
    // Chuyển đổi dataSource thành format mới
    const dataF = formattedData?.map((item) => {
      return {
        [headerMap.stt]: item.stt,
        [headerMap.project]: project.name,
        [headerMap.date_view]: item.date_view ? dayjs(item.date_view).format('DD/MM/YYYY') : '-',
        [headerMap.time]: item.date_view ? dayjs(item.date_view).format('HH:mm:ss') : '-',
        [headerMap.customer_name]: item.customer_name,
        [headerMap.customer_phone]: item.customer_phone,
        [headerMap.customer_email]: item.customer_email,
        [headerMap.created_at]: item.created_at ? dayjs(item.created_at).format('HH:mm:ss DD/MM/YYYY') : '-'
      }
    })

    const ws = XLSX.utils.json_to_sheet(dataF)
    // Định nghĩa độ rộng của từng cột
    ws['!cols'] = [
      { wch: 5 }, // Độ rộng cột Project
      { wch: 30 }, // Độ rộng cột Customer Name
      { wch: 15 }, // Độ rộng cột Customer Phone
      { wch: 25 }, // Độ rộng cột Customer Email
      { wch: 25 }, // Độ rộng cột Customer Email
      { wch: 25 }, // Độ rộng cột Customer Email
      { wch: 25 }, // Độ rộng cột Customer Email
      { wch: 25 } // Độ rộng cột Customer Email
    ]
    // Đổi tên tiêu đề cột
    XLSX.utils.sheet_add_aoa(
      ws,
      [
        [
          headerMap.stt,
          headerMap.project,
          headerMap.date_view,
          headerMap.time,
          headerMap.customer_name,
          headerMap.customer_phone,
          headerMap.customer_email,
          headerMap.created_at
        ]
      ],
      { origin: 'A1' }
    )

    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Danh sách')

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const dataEx = new Blob([excelBuffer], { type: 'application/octet-stream' })
    saveAs(dataEx, 'danh_sach_dang_ky_xem_nha.xlsx')
  }
  return (
    <>
      <ModalCustom
        title="Danh sách đăng ký xem nhà"
        visible={isModalOpen}
        centered
        width={1000}
        onCancel={() => {
          onClose()
        }}
        cancelText="Đóng"
        footer={''}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="primary"
            onClick={exportToExcel}
            style={{ marginBottom: 16 }}
          >
            Xuất Excel
          </Button>
        </div>
        <Table
          loading={loading}
          columns={columns}
          dataSource={formattedData || []}
          pagination={{ pageSize: 5 }}
        />
      </ModalCustom>
      <ModalConfirm />
    </>
  )
}
export default ModalListHouse
